import React, { ComponentProps } from 'react'
import { Field } from 'react-final-form'

import { hasError as formHasError } from 'Services/Utils/form'

import Select from './Select'

type Props = ComponentProps<typeof Select> & {
  name: string
  checkErrorIfDirty?: boolean
  displayError?: boolean
  initialValue?: any
  format?: any
  parse?: any
}

function SelectField({
  checkErrorIfDirty,
  displayError,
  name,
  caption,
  initialValue,
  format,
  parse,
  ...rest
}: Props) {
  return (
    <Field
      format={format}
      initialValue={initialValue}
      name={name}
      parse={parse}
    >
      {({ input, meta }) => {
        const { hasError, error } = formHasError(meta, checkErrorIfDirty)

        return (
          <Select
            {...input}
            {...rest}
            caption={(displayError && error) || caption}
            danger={hasError}
          />
        )
      }}
    </Field>
  )
}

SelectField.defaultProps = {
  displayError: true,
} as Props

export default SelectField
